import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowRight } from "lucide-react";
import { ContentHeader, CTASection } from "@/components/content";

export const Route = createFileRoute('/comparisons/')({
  component: ComparisonsPage,
  head: () => ({
    meta: [
      { title: 'Comparisons | Matricks' },
      { name: 'description', content: 'See how Matricks compares to Kong, Apigee, AWS API Gateway, Langfuse, and LangChain. Detailed feature comparisons to help you choose.' },
    ],
  }),
});

const comparisons = [
  {
    competitor: "Kong",
    category: "API Gateway",
    description:
      "Compare Matricks and Kong for API gateway and management. See how our approach to integrations and AI differs.",
    href: "/comparisons/kong",
  },
  {
    competitor: "Apigee",
    category: "API Management",
    description:
      "Matricks vs Google Apigee. Compare features, pricing, and ease of use for enterprise API management.",
    href: "/comparisons/apigee",
  },
  {
    competitor: "AWS API Gateway",
    category: "API Gateway",
    description:
      "Compare Matricks with AWS API Gateway. Multi-cloud flexibility vs AWS-native integration.",
    href: "/comparisons/aws-api-gateway",
  },
  {
    competitor: "Langfuse",
    category: "LLM Observability",
    description:
      "Matricks vs Langfuse for LLM observability and management. Compare AI gateway capabilities.",
    href: "/comparisons/langfuse",
  },
  {
    competitor: "LangChain",
    category: "AI Agent Framework",
    description:
      "Compare Matricks AI Agents Platform with LangChain. Visual builder vs code-first approach.",
    href: "/comparisons/langchain",
  },
];

function ComparisonsPage() {
  return (
    <div>
      <ContentHeader
        title="How Matricks Compares"
        description="See how Matricks stacks up against other platforms. We believe in transparency—here's an honest look at how we differ from alternatives."
        breadcrumbs={[{ label: "Home", href: "/" }, { label: "Comparisons" }]}
      />

      <div className="mt-16 grid grid-cols-1 gap-6">
        {comparisons.map((comparison) => (
          <Link
            key={comparison.competitor}
            to={comparison.href as any}
            className="group rounded-2xl border bg-card p-6 transition-all hover:shadow-lg hover:border-primary/50"
          >
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <span className="text-sm text-muted-foreground">{comparison.category}</span>
                <h3 className="text-xl font-semibold mt-1 group-hover:text-primary transition-colors">
                  Matricks vs {comparison.competitor}
                </h3>
                <p className="text-muted-foreground mt-2">{comparison.description}</p>
              </div>
              <ArrowRight className="h-6 w-6 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
            </div>
          </Link>
        ))}
      </div>

      <CTASection
        title="Ready to try Matricks?"
        description="Start your free trial and see the difference for yourself."
        primaryAction={{ label: "Start Free Trial", href: "/login" }}
        secondaryAction={{ label: "Contact Sales", href: "/info/contact" }}
        background="muted"
      />
    </div>
  );
}
